import classnames from 'classnames';
import invariant from 'invariant';
import { forwardRef, useContext, useEffect, useState } from 'react';

import { AccordionContext } from '../Accordion.types';

import styles from './AccordionItem.module.scss';
import { AccordionItemContext, AccordionItemProps } from './AccordionItem.types';

export const AccordionItem = forwardRef<HTMLDivElement, AccordionItemProps>(
  (
    {
      className,
      isOpen: _isOpen,
      setIsOpen: _setIsOpen,
      disabled = false,
      defaultOpen = false,
      ...props
    },
    ref
  ) => {
    const context = useContext(AccordionContext);
    invariant(context, 'AccordionItem must be used within Accordion');

    const [isOpen, setIsOpen] = useState(_isOpen ?? defaultOpen);

    useEffect(() => {
      if (_isOpen !== isOpen) _setIsOpen?.(isOpen);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_setIsOpen, isOpen]);
    useEffect(() => {
      if (_isOpen !== undefined) setIsOpen(_isOpen);
    }, [_isOpen]);

    return (
      <AccordionItemContext.Provider
        value={{ isOpen, setIsOpen, disabled: context.disabled || disabled }}
      >
        <div className={classnames(styles.item, className)} {...props} ref={ref} />
      </AccordionItemContext.Provider>
    );
  }
);
